import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import CustomNavbar from '../../../customNavbar';
import styles from './viewQuizTemplate.module.scss';
import { Accordion, Card, Col, Row, Button, Alert } from 'react-bootstrap';
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import { CustomButton } from '../../../../shared/customButton';
import CreateQuestionModal from './createQuestionModal';
import EditQuestionModal from './editQuestionModal';
import { activateQuizTemplate, deleteQuestionFromQuiz, disableQuizTemplate, getQuizTemplate, putBackToDraft, copyTemplateToNew, checkIfTemplateEligibleToDisableOrPutBackToEdit, changeQuestionOrder, editQuizTemplate, editQuestionToQuizTemplate } from '../../../../../services/util/quizTemplates';
import CSSLoader from '../../../../shared/cssLoader';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import EditQuizTemplate from './editQuizTemplateModal';
import { CustomConfirmationModal } from '../../../../shared/customConfirmationModal';
import { CustomMessagePopUpBox } from '../../../../shared/customMessagePopUpBox';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { CustomStatusLabel } from '../../../../shared/customStatusLabel';
import { Field, FieldArray, Formik, Form  } from 'formik';
import { CustomCloneConfirmationBox } from '../../../../shared/customCloneConfirmationBox';
import { CustomConfirmationWithCheckPopUpBox } from '../../../../shared/customConfirmationWithCheckPopUpBox';


const ViewQuizTemplates = (props) => {

    let [isURLLoading, setURLLoading] = useState(false);
    let [templateEditAlertPopUpOpen, setTemplateEditAlertPopUpOpen] = useState(false);
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [questionAccordionIcon, setQuestionAccordionIcon] = useState({});
    let [getDataIsLoading, getDataSetLoading] = useState(false);
    const [showAddQuestionModal, setShowAddQuestionModal] = useState(false);
    const [showEditQuestionModal, setShowEditQuestionModal] = useState(false);
    const [showEditQuizTemplateModal, setShowEditQuizTemplateModal] = useState(false);
    let [quizTemplateData, setQuizTemplateData] = useState();
    let [editQuestionData, setEditQuestionData] = useState();

    let [showActivateTemplatePopup, setShowActivateTemplatePopup] = useState(false);
    let [showDisablePopup, setShowDisablePopup] = useState(false);
    let [showBackToDraftPopup, setShowBackToDraftPopup] = useState(false);
    let [showBackToViewModePopup, setShowBackToViewModePopup] = useState(false);
    let [showCopyToNewPopup, setShowCopyToNewPopup] = useState(false);

    let [showNotEligibleForDisablePopup, setNotEligibleForDisablePopup] = useState(false);
    let [showNotEligibleForDraftPopup, setNotEligibleForDraftPopup] = useState(false);
    let [attachedPipelines, setAttachedPipelines] = useState([]);


    let [showQuesDeletePopup, setShowQuesDeletePopup] = useState(false);

    let [modalActionButtonLoading, setModalActionButtonLoading] = useState(false);
    let [disableButtonLoading, setDisableButtonLoading] = useState(false);
    let [putBackToDraftButtonLoading, setPutBackToDraftButtonLoading] = useState(false);

    let [selectedCloneQuizID, setSelectedCloneQuizID] = useState(null);
    let [isQuizCloneModalOpen, setIsQuizCloneModalOpen] = useState(false);
    const [isQuizCloneSubmit, setIsQuizCloneSubmit] = useState(false);

    let [questionCount, setQuestionCount] = useState();
    let [question_id, setQuestionid] = useState();
    let [editable, setEditable] = useState(false);
    let [attachedPipelineNames, setAttachedPipelineNames] = useState([]);
    let [isLoading, setIsLoading] = useState()

    const [isUnsavedChangesAvailable, setIsUnsavedChangesAvailable] = useState(false);

    // Initialize with an empty array
    const [questionStates, setQuestionStates] = useState([]);
    const [initialValues, setInitialValues] = useState({ questions: [] });
    let [values, setValues] = useState([]);
    const addNewState = () => {
        setQuestionStates([...questionStates, false]);
};

const toggleState = (index) => {
    const newQuestionStates = [...questionStates];
    newQuestionStates[index] = !newQuestionStates[index];
    setQuestionStates(newQuestionStates);
};

    let { id } = useParams();

    const history = useNavigate();
    const breadcrumb = [
        {
            pathaddress: '/app/company/templates/quiz-templates',
            pathname: 'Quiz Templates',
            isActive: false,
            key: 3 + 'Quiz Templates'
        },
        {
            pathaddress: `/app/company/quiz-template/${id}`,
            pathname: quizTemplateData?.name,
            isActive: true,
            key: 2 + quizTemplateData?.name
        }
    ]

    const getQuizTemplateValues = async () => {
        getDataSetLoading(true);
        let response = await getQuizTemplate(id);
        if (response.success === true) {
            setQuizTemplateData(response.data);
            setQuestionCount(response.data.question_count);
            getDataSetLoading(false);
            if(response.data.state === 0 && response.data.questions.length === 0) {
                setEditable(true);
            }else{
                setEditable(false);
            }
        }
        else {
            getDataSetLoading(true);
        }

    }

    const refreshData = async() => {
        getDataSetLoading(true);
        let response = await getQuizTemplate(id)
        if (response.success === true) {
            setQuizTemplateData(response.data);
            setQuestionCount(response.data.question_count);
            getDataSetLoading(false);
        }
        getDataSetLoading(false);
        setQuestionAccordionIcon(''); 
        setAccordionIcon(true);
    }

    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon)
    }

    const changeQuestionAccordionIcon = (value) => {
        setQuestionAccordionIcon((prevState) => ({
            ...prevState,
            [value]: {
                icon: !prevState[value]?.icon,
            },
        }));
    };

    const handleRemoveQuestion = (index, setFieldValue, values) => {
        // Make a copy of the current questions array
        const updatedQuestions = [...values.questions];
        // Remove the question at the specified index
        updatedQuestions.splice(index, 1);
        // Update Formik's values with the updated questions array
        setFieldValue('questions', updatedQuestions);
        setIsUnsavedChangesAvailable(true);
      };


    // functions for handle all modals
    const handleClose = () => {
        setShowAddQuestionModal(false);
        setShowEditQuestionModal(false);
        setShowEditQuizTemplateModal(false);
        setShowActivateTemplatePopup(false);
        setShowCopyToNewPopup(false)
        setShowDisablePopup(false);
        setShowQuesDeletePopup(false);
        setShowBackToDraftPopup(false);
        setNotEligibleForDisablePopup(false);
        setNotEligibleForDraftPopup(false)
        setAttachedPipelines([]);   
        setShowBackToViewModePopup(false);  
        setEditQuestionData(null);
    }
    const handleShow = () => setShowAddQuestionModal(true);

    const handleShowEdit = (values, ques_no) => {
        let editModalData = {
            rowValues: values,
            question_no: ques_no + 1,
            questionTemplateName: quizTemplateData?.name
        }
        setEditQuestionData(editModalData);
        setShowEditQuestionModal(true);
        setIsUnsavedChangesAvailable(true);
    }

    const handleShowActivatePopup = () => { setShowActivateTemplatePopup(true) }

    const handleShowQuizCopyToNewPopup = async (Value) => {
        setIsQuizCloneModalOpen(true);
        setSelectedCloneQuizID(Value)
    }


    const handleShowEditQuizModal = () => { setShowEditQuizTemplateModal(true); }

    const handleShowDeleteQuestion = (values, index) => {
         setShowQuesDeletePopup(true); 
         setQuestionid(values._id)
         }

    const activateTemplate = async () => {
        setModalActionButtonLoading(true)
        let response = await activateQuizTemplate(id);
        if (response.success == true) {
            setModalActionButtonLoading(false)
            handleClose();
            setQuestionAccordionIcon('');
        } else {
            setModalActionButtonLoading(false)
        }
        getQuizTemplateValues();
    }

    const disableTemplate = async () => {
        setModalActionButtonLoading(true)
        let response = await disableQuizTemplate(id);
        if (response.success == true) {
            getQuizTemplateValues();
            setModalActionButtonLoading(false)
            handleClose();
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const deleteQuestionFromTemplate = async () => {
        setModalActionButtonLoading(true)
        let response = await deleteQuestionFromQuiz(id, question_id);
        if (response.success == true) {
            getQuizTemplateValues();
            setModalActionButtonLoading(false)
            handleClose();
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const putToDraftAgain = async () => {
        setModalActionButtonLoading(true)
        let response = await putBackToDraft(id);
        if (response.success == true) {
            getQuizTemplateValues();
            setModalActionButtonLoading(false)
            handleClose();
            setQuestionAccordionIcon('');
        } else {
            setModalActionButtonLoading(false)
        }
    }
        //submit clone values function
        async function submitQuizCloneValues(values) {
            setIsQuizCloneSubmit(true)
            let respond = await copyTemplateToNew(id, values.newCloneName)
            if (respond.success === true) {
                history(`/company/templates/quiz-templates`);
                handleClose();
                setSelectedCloneQuizID(null);
                setIsQuizCloneSubmit(false);
                setIsQuizCloneModalOpen(false);
            } else {
                setIsQuizCloneSubmit(false);
                setIsQuizCloneModalOpen(false);
            }
        }

    const backtoViewModeModalOpening = async (values) => {

        //check if new questions are added
        if ((values.length > questionCount) || isUnsavedChangesAvailable) {
            setShowBackToViewModePopup(true)
        } else {
            setEditable(false);
        }

    }

    const checkEligiblityToDisable = async () => {
        setDisableButtonLoading(true)
        let response = await checkIfTemplateEligibleToDisableOrPutBackToEdit(id);
        if (response.success == true) {

            if (response.data.is_eligible) {
                setShowDisablePopup(true);
            }
            else {
                let pipeline_name_string = []
                for (let index = 0; index < (response.data.pipelines_array).length; index++) {
                    pipeline_name_string.push(response.data.pipelines_array[index].pipeline_name);
                }

                setAttachedPipelines(pipeline_name_string);
                setNotEligibleForDisablePopup(true);
            }

            setDisableButtonLoading(false)
        } else {
            setDisableButtonLoading(false)
        }
    }

    function truncateText(text, maxLength) {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    }
    
    const chekQuizTemplateEditEligibale = async () => {
        setIsLoading(true);
        let response = await checkIfTemplateEligibleToDisableOrPutBackToEdit(id);
        if (response) {
            const pipelineNames = response.data.pipelines_array.map(pipeline => pipeline.pipeline_name);
            setAttachedPipelineNames(pipelineNames);
            setTemplateEditAlertPopUpOpen(true)
            setIsLoading(false);
        }  
    }

    useEffect(() => {
        getQuizTemplateValues()
        addNewState()
    }, [])

    const handleOnDragEndDraftMode = async (result) => {
        if (!result.destination) {
            return;
        }
        const questionArray = Array.from(quizTemplateData.questions);
        const [reorderedItem] = questionArray.splice(result.source.index, 1);
        questionArray.splice(result.destination.index, 0, reorderedItem);
        quizTemplateData.questions = [];
        setQuizTemplateData(prevData => ({ ...prevData, questions: questionArray }));
        await changeQuestionOrder(id, questionArray);
    };

    useEffect(() => {
        if (quizTemplateData) {
            setInitialValues({ questions: quizTemplateData.questions || [] });
        }
    }, [quizTemplateData]);

    return (
        <div>
            
            {
                showEditQuizTemplateModal === true ?
                    <EditQuizTemplate showModal={showEditQuizTemplateModal} handleClose={handleClose} refreshData={refreshData} id={id} data={quizTemplateData} />
                    : null
            }
            <Helmet>
                <title>Quiz Template | HireTrace</title>
            </Helmet>

            {getDataIsLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :

                <div>
                    {/* Template Edit alert Start */}
                    <CustomConfirmationModal
                        show={templateEditAlertPopUpOpen}
                        confirmationType={((values?.questions)&&(values?.questions.length > 0)) || (attachedPipelineNames.length > 0) ? 'warning' : 'default'}
                        cancelIconclick={() => {
                            setTemplateEditAlertPopUpOpen(false);
                            if (quizTemplateData?.questions.length === 0) { // reload when questions are empty
                                getDataSetLoading(true);
                                getQuizTemplateValues();
                            }
                        }}
                        onSecondaryBtnClick={() => {
                            setTemplateEditAlertPopUpOpen(false);
                            if (quizTemplateData?.questions.length === 0) {
                                getDataSetLoading(true);
                                getQuizTemplateValues();
                            }
                        }}

                        onPrimaryBtnClick={async () => {
                            setModalActionButtonLoading(true);
                            try {
                                await editQuestionToQuizTemplate(values.questions, id);
                                setModalActionButtonLoading(false);
                                setTemplateEditAlertPopUpOpen(false);
                                refreshData();
                                setEditable(false)
                            } catch (error) {
                                setModalActionButtonLoading(false);
                            }
                        }}
                        
                        
                        isSecondaryBtnDisabled={getDataIsLoading}
                        isPrimaryBtnDisabled={(values?.questions) && values?.questions.length === 0}
                        primaryBtnBackSideIcon={getDataIsLoading ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={(values?.questions) && (values?.questions.length > 0)&& (attachedPipelineNames.length > 0) ? (
                            <div>
                                You are about to change the quiz template. This template is already attached to the pipeline(s). New changes will apply to the attached pipeline(s) as well.
                                <br />
                                <br />
                                <p className={styles.templateEditPopText}>Pipeline Name(s)</p>
                                <strong>
                                    {attachedPipelineNames.map((name, index) => (
                                        <span key={index}>
                                            {name}
                                            {index < attachedPipelineNames.length - 1 ? <br /> : null}
                                        </span>
                                    ))}
                                </strong>
                            </div>
                        ) : (
                                (values?.questions) && values?.questions.length === 0 ? "You can't delete all questions in this activated template, at least one question must be there." : "You are about to save changes to the quiz template."
                        )}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, Please"
                    />

                    {/* Template Edit alert End */}
                    {/* activate template modal */}
                    <CustomConfirmationModal
                        show={showActivateTemplatePopup}
                        confirmationType='success'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={activateTemplate}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You want to activate the quiz. After activating, you can use this template in vacancy pipeline steps to evaluate candidates`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnId="adminPanel_evaluationTemplates_quizTemplates_viewQuizTemplate_yesActivateBtnId"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, Activate!"
                    />
                    {/* not eligible to put template back to draft mode messsage modal */}
                    <CustomMessagePopUpBox
                        show={showNotEligibleForDraftPopup}
                        confirmationType='warning'
                        cancelIconclick={handleClose}
                        onPrimaryBtnClick={handleClose}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Cannot Put Back To Draft"
                        message={(
                            <div className={styles.templateEditPopDiv}>
                                You cannot put this template back to draft mode. Because the templates is attached with active piepelines !
                                <br />
                                <p className={styles.templateEditPopText}>Attached active Pipeline(s)</p>
                                <strong>
                                    {attachedPipelines.map((name, index) => (
                                        <span>
                                            {name}
                                        </span>
                                    ))}
                                </strong>
                            </div>)}
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="primaryBtn"
                        primaryBtnLabel="Ok"
                    />
                    {/* put quiz template back to draft modal */}
                    <CustomConfirmationModal
                        show={showBackToDraftPopup}
                        confirmationType='success'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={putToDraftAgain}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You want to put this question template back to draft mode`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Back To Draft!"
                    />
                     {/* back to view mode modal */}
                     <CustomConfirmationModal
                        show={showBackToViewModePopup}
                        confirmationType='warning'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={() => {
                            setEditable(false);
                            setShowBackToViewModePopup(false);
                            getQuizTemplateValues();
                            setEditable(false);
                            setIsUnsavedChangesAvailable(false);
                          }}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`Entering view mode should reset your changes unless you use the "Save Template" option.`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="warningBtn"
                        primaryBtnLabel="Back To View Mode"
                    />
                    {/* quiz modal start */}
                    {
                        <CustomCloneConfirmationBox
                            show={isQuizCloneModalOpen}
                            confirmationType='default'
                            cancelIconclick={() => setIsQuizCloneModalOpen(false)}
                            onSecondaryBtnClick={() => setIsQuizCloneModalOpen(false)}
                            onFormSubmit={submitQuizCloneValues}
                            isSecondaryBtnDisabled={isQuizCloneSubmit === true ? true : false}
                            isPrimaryBtnDisabled={isQuizCloneSubmit === true ? true : false}
                            primaryBtnBackSideIcon={isQuizCloneSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                            preCheckedCondition={true}
                            topic="Clone Quiz Template"
                            message={`You are trying to clone a quiz template.`}
                            textBoxLabel={`Enter new template name`}
                            secondaryBtnName="backBtn"
                            secondaryBtnType="button"
                            secondaryBtnCssType="primaryBtn"
                            secondaryBtnLabel="Cancel"
                            primaryBtnName="submitCloneBtn"
                            primaryBtnType="submit"
                            primaryBtnCssType="successBtn"
                            primaryBtnLabel="Yes, clone template"
                            textBoxPlaceholder={`Ex: Software Engineer Quiz`}
                        />}
                    {/* quiz modal end */}
                    <CustomMessagePopUpBox
                        show={showNotEligibleForDisablePopup}
                        confirmationType='warning'
                        cancelIconclick={handleClose}
                        onPrimaryBtnClick={handleClose}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Disabling is not permitted?"
                        message={(
                            <div className={styles.templateEditPopDiv}>
                                Disabling templates which  are still in use is not permitted !
                                <br />
                                <p className={styles.templateEditPopSecondText}>You can't disable this quiz template, because this template is attached with active pipeline(s). If you need to disable this, please remove this template form attached active pipeline(s) or disable those pipeline(s).</p>
                                <p className={styles.templateEditPopText}>Attached active Pipeline(s)</p>
                                <strong>
                                    {attachedPipelines.map((name, index) => (
                                        <div>
                                            {name}
                                        </div>
                                    ))}
                                </strong>
                            </div>)}
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="primaryBtn"
                        primaryBtnLabel="Ok"
                    />
                    {/* disable template modal */}
                    <CustomConfirmationWithCheckPopUpBox
                        show={showDisablePopup}
                        confirmationType='danger'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onFormSubmit={disableTemplate}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic={"Are you sure?"}
                        message="You are about to disable this quiz template !"
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel={"Cancel"}
                        primaryBtnName={"submitBtn"}
                        primaryBtnType={"submit"}
                        primaryBtnCssType={"dangerBtn"}
                        primaryBtnLabel={"Yes, disable it!"}
                        checkboxLabel={"I understand that after disabling the quiz template, I cannot use it in pipelines. Also, this action cannot be undone."}
                    />
                    {/* disable template modal End */}

                    {/* question delete modal */}
                    <CustomConfirmationModal
                        show={showQuesDeletePopup}
                        confirmationType='danger'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={deleteQuestionFromTemplate}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You want to delete this question ? This cannot be undone`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnId="adminPanel_evaluationTemplates_quizTemplates_viewQuizTemplate_quizDeleteYesDeleteBtnId"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, Delete!"
                    />


                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>
                        
                   

                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        onSubmit={async (values) => {
                            await chekQuizTemplateEditEligibale();
                            setValues(values);
                            setIsUnsavedChangesAvailable(false);
                        }}
                    >
                        {({ values, handleSubmit, setFieldValue }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                {showEditQuestionModal && (
                                    <EditQuestionModal
                                        showModal={showEditQuestionModal}
                                        tempalteState={quizTemplateData?.state}
                                        setFieldValue={setFieldValue}
                                        handleClose={handleClose}
                                        setVilrefreshData={refreshData}
                                        id={id}
                                        data={editQuestionData}
                                    />
                                )}
                                {/*Header start*/}
                                <div className='mt-0'>
                                    <Row className='mt-0'>
                                        <div className={styles.mainHeaderOptionsDiv}>
                                            <Col className={styles.mainHeaderLeftCornerOption}>
                                                <Row className={styles.mainHeaderLeftCornerOptionRow}>
                                                    <div className='mt-2 ms-0'>
                                                        {quizTemplateData?.state === 0
                                                            ?
                                                            <CustomStatusLabel
                                                                label="Draft"
                                                                type="warningStatus"
                                                            />
                                                            :
                                                            quizTemplateData?.state === -10 ?
                                                                <CustomStatusLabel
                                                                    label="Disabled"
                                                                    type="dangerStatus"
                                                                />
                                                                :
                                                                <CustomStatusLabel
                                                                    label="Active"
                                                                    type="successStatus"
                                                                />
                                                        }

                                                    </div>
                                                </Row>
                                            </Col>

                                            <Col>
                                                <Row >
                                                    <div className={styles.mainHeaderRightCornerOptionRow}>
                                                        <div className={styles.LeftCornerOptionReset} onClick={() => refreshData()}>
                                                            <svg className={getDataSetLoading === true ? styles.refreshSvg : null} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                <path d="M1.66675 8.33333C1.66675 8.33333 3.33757 6.05685 4.69494 4.69854C6.05232 3.34022 7.92808 2.5 10.0001 2.5C14.1422 2.5 17.5001 5.85786 17.5001 10C17.5001 14.1421 14.1422 17.5 10.0001 17.5C6.58084 17.5 3.69601 15.2119 2.79322 12.0833M1.66675 8.33333V3.33333M1.66675 8.33333H6.66675" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </div>
                                                        {
                                                            <div className='ms-2'>
                                                                <CustomButton
                                                                    buttonType="button"
                                                                    label="Clone"
                                                                    type="defaultBtn"
                                                                    id="Clone"
                                                                    // disabled={quizTemplateData?.questions.length <= 0}
                                                                    frontIcon={
                                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M4.16797 12.5003C3.3914 12.5003 3.00311 12.5003 2.69683 12.3735C2.28845 12.2043 1.96399 11.8798 1.79484 11.4715C1.66797 11.1652 1.66797 10.7769 1.66797 10.0003V4.33366C1.66797 3.40024 1.66797 2.93353 1.84962 2.57701C2.00941 2.2634 2.26438 2.00844 2.57798 1.84865C2.9345 1.66699 3.40121 1.66699 4.33464 1.66699H10.0013C10.7779 1.66699 11.1662 1.66699 11.4724 1.79386C11.8808 1.96302 12.2053 2.28747 12.3744 2.69585C12.5013 3.00214 12.5013 3.39042 12.5013 4.16699M10.168 18.3337H15.668C16.6014 18.3337 17.0681 18.3337 17.4246 18.152C17.7382 17.9922 17.9932 17.7372 18.153 17.4236C18.3346 17.0671 18.3346 16.6004 18.3346 15.667V10.167C18.3346 9.23357 18.3346 8.76686 18.153 8.41034C17.9932 8.09674 17.7382 7.84177 17.4246 7.68198C17.0681 7.50033 16.6014 7.50033 15.668 7.50033H10.168C9.23455 7.50033 8.76784 7.50033 8.41132 7.68198C8.09771 7.84177 7.84275 8.09674 7.68296 8.41034C7.5013 8.76686 7.5013 9.23357 7.5013 10.167V15.667C7.5013 16.6004 7.5013 17.0671 7.68296 17.4236C7.84275 17.7372 8.09771 17.9922 8.41132 18.152C8.76784 18.3337 9.23455 18.3337 10.168 18.3337Z" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                    }
                                                                    handleClick={handleShowQuizCopyToNewPopup}
                                                                />
                                                            </div>
                                                        }
                                                        {editable && quizTemplateData?.state !== 0 &&
                                                            <div className='ms-2'>
                                                                <CustomButton
                                                                    buttonType="button"
                                                                    label="Back to View Mode"
                                                                    type="secondaryBtn"
                                                                    id="view_mode"
                                                                    frontIcon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                            <g clip-path="url(#clip0_2101_3258)">
                                                                                <path d="M2.5 7.49984H13.75C15.8211 7.49984 17.5 9.17877 17.5 11.2498C17.5 13.3209 15.8211 14.9998 13.75 14.9998H10M2.5 7.49984L5.83333 4.1665M2.5 7.49984L5.83333 10.8332" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_2101_3258">
                                                                                    <rect width="20" height="20" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    }
                                                                    handleClick={() => {backtoViewModeModalOpening(values.questions)}}
                                                                />
                                                            </div>
                                                        }
                                                        {editable && quizTemplateData?.state !== 0 &&
                                                            <div className='ms-2'>
                                                                <CustomButton
                                                                id="save_template"
                                                                buttonType="submit"
                                                                label="Save Template"
                                                                type="primaryBtn"
                                                                handleClick={() => { handleSubmit() }}
                                                                frontIcon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                        <g clip-path="url(#clip0_2101_3258)">
                                                                            <path d="M13 6H6.6C6.03995 6 5.75992 6 5.54601 5.89101C5.35785 5.79513 5.20487 5.64215 5.10899 5.45399C5 5.24008 5 4.96005 5 4.4V1M15 19V12.6C15 12.0399 15 11.7599 14.891 11.546C14.7951 11.3578 14.6422 11.2049 14.454 11.109C14.2401 11 13.9601 11 13.4 11H6.6C6.03995 11 5.75992 11 5.54601 11.109C5.35785 11.2049 5.20487 11.3578 5.10899 11.546C5 11.7599 5 12.0399 5 12.6V19M19 7.32548V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H12.6745C13.1637 1 13.4083 1 13.6385 1.05526C13.8425 1.10425 14.0376 1.18506 14.2166 1.29472C14.4184 1.4184 14.5914 1.59135 14.9373 1.93726L18.0627 5.06274C18.4086 5.40865 18.5816 5.5816 18.7053 5.78343C18.8149 5.96237 18.8957 6.15746 18.9447 6.36154C19 6.59171 19 6.8363 19 7.32548Z" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_2101_3258">
                                                                                <rect width="20" height="20" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                }
                                                                backicon={
                                                                    isLoading === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                                        : ''
                                                                }
                                                            />

                                                            </div>
                                                        }
                                                        

                                                        {quizTemplateData?.state === 0 && 

                                                            <div className='ms-3'>
                                                                <CustomButton
                                                                    buttonType="button"
                                                                    label="Activate Template"
                                                                    id="adminPanel_evaluationTemplates_quizTemplates_viewQuizTemplate_activateQuizBtnId"
                                                                    type="secondaryBtn"
                                                                    handleClick={handleShowActivatePopup}
                                                                    disabled={(questionCount === 0) ? true : false}
                                                                />
                                                            </div>
                                                        }

                                                        {!editable && quizTemplateData?.state !== 0 &&
                                                            <div className='ms-2'>
                                                                <CustomButton
                                                                    buttonType="button"
                                                                    label="Edit"
                                                                    type="secondaryBtn"
                                                                    id="edit_mode"
                                                                    frontIcon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                            <g clipPath="url(#clip0_3929_6825)">
                                                                                <path d="M9.1665 3.3332H5.6665C4.26637 3.3332 3.56631 3.3332 3.03153 3.60568C2.56112 3.84536 2.17867 4.22782 1.93899 4.69822C1.6665 5.233 1.6665 5.93307 1.6665 7.3332V14.3332C1.6665 15.7333 1.6665 16.4334 1.93899 16.9682C2.17867 17.4386 2.56112 17.821 3.03153 18.0607C3.56631 18.3332 4.26637 18.3332 5.6665 18.3332H12.6665C14.0666 18.3332 14.7667 18.3332 15.3015 18.0607C15.7719 17.821 16.1543 17.4386 16.394 16.9682C16.6665 16.4334 16.6665 15.7333 16.6665 14.3332V10.8332M6.66648 13.3332H8.06193C8.46959 13.3332 8.67341 13.3332 8.86522 13.2871C9.03528 13.2463 9.19786 13.179 9.34698 13.0876C9.51517 12.9845 9.6593 12.8404 9.94755 12.5521L17.9165 4.5832C18.6069 3.89284 18.6069 2.77355 17.9165 2.0832C17.2261 1.39284 16.1069 1.39284 15.4165 2.0832L7.44753 10.0521C7.15928 10.3404 7.01515 10.4845 6.91208 10.6527C6.8207 10.8018 6.75336 10.9644 6.71253 11.1345C6.66648 11.3263 6.66648 11.5301 6.66648 11.9378V13.3332Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_3929_6825">
                                                                                    <rect width="20" height="20" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    }
                                                                    handleClick={() => setEditable(true)}
                                                                    disabled={isLoading === true ? true : false}
                                                                    backicon={isLoading === true && <i className="fas fa-circle-notch fa-spin"></i>}
                                                                />
                                                            </div>
                                                        }

                                                    </div>
                                                </Row>
                                            </Col>
                                        </div>
                                    </Row>
                                </div>
                                {/*Quiz Details Start*/}
                                <div className='mt-3'>
                                    <Row className={styles.IntroductionOptionsDiv}>
                                        <Col sm={7} className='mb-3'>
                                            <div className={styles.introductionMainRightDiv}>
                                                <Row className={styles.introductionRightDiv}>
                                                    <Col sm={4}>
                                                        <div className={styles.introductionRightDivText}>
                                                            <div className='m-0 ps-0'>
                                                                <p className={styles.introductionRightLabelText}>Quiz Name</p>
                                                            </div>
                                                            <div className='m-0 ps-0'>
                                                                <p className={styles.introductionRightValueText}>{quizTemplateData?.name}</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <div className={styles.introductionRightSecondInsideDiv}>
                                                            <div className='m-0 ps-3'>
                                                                <p className={styles.introductionRightLabelText}>Quiz Specialization</p>
                                                            </div>
                                                            <div className='m-0 ps-3'>
                                                                <p className={styles.introductionRightValueText}>{quizTemplateData?.specialization}</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className={styles.introductionRightSecondInsideDiv}>
                                                            <div className='m-0 ps-3'>
                                                                <p className={styles.introductionRightLabelText}>Time Period</p>
                                                            </div>
                                                            <div className='m-0 ps-3'>
                                                                <p className={styles.introductionRightValueText}>{quizTemplateData?.duration} mins</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <div className={styles.introductionRightDivEditBtn}>
                                                        {editable && quizTemplateData?.state !== 0 &&
                                                            <CustomButton
                                                                buttonType="button"
                                                                label="Edit"
                                                                type="defaultSmallBtn"
                                                                id="template_details_edit_button"
                                                                frontIcon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                        <g clip-path="url(#clip0_2101_3258)">
                                                                            <path d="M9.16675 3.33344H5.66675C4.26662 3.33344 3.56655 3.33344 3.03177 3.60593C2.56137 3.84561 2.17892 4.22806 1.93923 4.69847C1.66675 5.23324 1.66675 5.93331 1.66675 7.33344V14.3334C1.66675 15.7336 1.66675 16.4336 1.93923 16.9684C2.17892 17.4388 2.56137 17.8213 3.03177 18.061C3.56655 18.3334 4.26662 18.3334 5.66675 18.3334H12.6667C14.0669 18.3334 14.7669 18.3334 15.3017 18.061C15.7721 17.8213 16.1546 17.4388 16.3943 16.9684C16.6667 16.4336 16.6667 15.7336 16.6667 14.3334V10.8334M6.66673 13.3334H8.06218C8.46983 13.3334 8.67366 13.3334 8.86547 13.2874C9.03553 13.2466 9.1981 13.1792 9.34722 13.0878C9.51542 12.9848 9.65954 12.8406 9.9478 12.5524L17.9167 4.58344C18.6071 3.89309 18.6071 2.7738 17.9167 2.08344C17.2264 1.39309 16.1071 1.39308 15.4167 2.08344L7.44778 10.0524C7.15952 10.3406 7.0154 10.4848 6.91233 10.653C6.82094 10.8021 6.7536 10.9647 6.71278 11.1347C6.66673 11.3265 6.66673 11.5304 6.66673 11.938V13.3334Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_2101_3258">
                                                                                <rect width="20" height="20" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                }
                                                                handleClick={() => handleShowEditQuizModal()}

                                                            />
                                                        }
                                                    </div>
                                                </Row>
                                                <Row className={styles.introductionRightSecondDiv}>
                                                    <Col className='mt-2 p-0' >
                                                        <div className='m-0 ps-0'>
                                                            <p className={styles.introductionRightLabelText}>Study Areas</p>
                                                        </div>
                                                        <div className='m-0 ps-0'>
                                                            <p className={styles.introductionRightValueText}>{quizTemplateData?.subject_areas.join(' | ')}</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className={styles.introductionRightSecondDiv}>
                                                    <Col className='mt-2 p-0' >
                                                        <div className='m-0 ps-0'>
                                                            <p className={styles.introductionRightLabelText}>Quiz Description</p>
                                                        </div>
                                                        <div className='m-0 ps-0'>
                                                            <p className={styles.introductionRightValueText}>{quizTemplateData?.description ? quizTemplateData?.description : 'No Decription to display'}</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className={styles.BodyContainer}>
                                    <Row className={styles.bodyRow}>
                                        <Col >
                                            <Col>
                                                {values.questions.length !== 0 ? (
                                                    <FieldArray name="questions">
                                                        {(arrayHelpers) => {
                                                            const handleOnDragEnd = async (result, arrayHelpers) => {
                                                                if (!result.destination) {
                                                                    return;
                                                                }
                                                                const { source, destination } = result;
                                                                arrayHelpers.move(source.index, destination.index);
                                                            };
                                                            return(
                                                            <DragDropContext onDragEnd={(result) => {
                                                                if(quizTemplateData?.state === 0){
                                                                    handleOnDragEndDraftMode(result)
                                                                    setIsUnsavedChangesAvailable(true);
                                                                }else{
                                                                    handleOnDragEnd(result, arrayHelpers)
                                                                    setIsUnsavedChangesAvailable(true);
                                                                }
                                                            } }>
                                                                <Droppable droppableId="questions">
                                                                    {(provided) => (
                                                                        <div ref={provided.innerRef} {...provided.droppableProps}>
                                                                            {values.questions.map((question, i) => (
                                                                                <Draggable key={i} draggableId={`questions-${i}`} index={i} isDragDisabled={(quizTemplateData?.state!==0 && !editable)}>
                                                                                    {(provided) => (
                                                                                        <Row className="questionMiddleDiv" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                            <Col className={styles.questionMiddleMainRow}>
                                                                                                <div className={(editable || quizTemplateData?.state ===0 )? styles.questionMiddleDragIcon : styles.questionMiddleDragIconNone} {...provided.dragHandleProps}>
                                                                                                    {(editable || quizTemplateData?.state ===0 )&&
                                                                                                        <>
                                                                                                            <div className={styles.questionMiddleDragIconDiv}>
                                                                                                                <svg
                                                                                                                    width="16"
                                                                                                                    height="17"
                                                                                                                    viewBox="0 0 16 17"
                                                                                                                    fill="none"
                                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                                >
                                                                                                                    <g id="menu-05">
                                                                                                                        <path
                                                                                                                            id="Icon"
                                                                                                                            d="M2 6.16666H14M2 10.8333H14"
                                                                                                                            stroke="#475467"
                                                                                                                            strokeWidth="1.33333"
                                                                                                                            strokeLinecap="round"
                                                                                                                            strokeLinejoin="round"
                                                                                                                        />
                                                                                                                    </g>
                                                                                                                </svg>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    }
                                                                                                </div>
                                                                                                <div className={styles.questionMiddleQuestionDiv}>
                                                                                                    <div className={styles.questionAreaHeaderDiv}>
                                                                                                        <div className={styles.introductionStepMain}>
                                                                                                            <div className={styles.introductionStep}>
                                                                                                                <p>Q{i + 1}</p>
                                                                                                            </div>
                                                                                                            <p className={styles.questionAreaHeaderMainText} id={`adminPanel_evaluationTemplates_quizTemplates_viewQuizTemplate_questionTextId.${i}`}>
                                                                                                                <span className='ms-3'>{truncateText(question.question, 100)}</span>
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className={styles.secondQuestionDiv}>
                                                                                                            <div className={styles.alertBox}>
                                                                                                                {question.is_multiple_answer_question ? (
                                                                                                                    <CustomAlertBox svgStatus="false" alertType="defaultAlert" id={`adminPanel_evaluationTemplates_quizTemplates_viewQuizTemplate_questionAnswerTypeMutiple.${i}`} alertBodyText="Multiple Answers" />
                                                                                                                ) : (
                                                                                                                    <CustomAlertBox svgStatus="false" alertType="defaultAlert" id={`adminPanel_evaluationTemplates_quizTemplates_viewQuizTemplate_questionAnswerType.${i}`} alertBodyText="Single Answer" />
                                                                                                                )}
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                {(editable || quizTemplateData?.state === 0) && (
                                                                                                                    <div>
                                                                                                                        <svg onClick={() => handleShowEdit(values.questions[i], i)} className={styles.questionEditIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                                                            <g clipPath="url(#clip0_3929_6825)">
                                                                                                                                <path d="M9.1665 3.3332H5.6665C4.26637 3.3332 3.56631 3.3332 3.03153 3.60568C2.56112 3.84536 2.17867 4.22782 1.93899 4.69822C1.6665 5.233 1.6665 5.93307 1.6665 7.3332V14.3332C1.6665 15.7333 1.6665 16.4334 1.93899 16.9682C2.17867 17.4386 2.56112 17.821 3.03153 18.0607C3.56631 18.3332 4.26637 18.3332 5.6665 18.3332H12.6665C14.0666 18.3332 14.7667 18.3332 15.3015 18.0607C15.7719 17.821 16.1543 17.4386 16.394 16.9682C16.6665 16.4334 16.6665 15.7333 16.6665 14.3332V10.8332M6.66648 13.3332H8.06193C8.46959 13.3332 8.67341 13.3332 8.86522 13.2871C9.03528 13.2463 9.19786 13.179 9.34698 13.0876C9.51517 12.9845 9.6593 12.8404 9.94755 12.5521L17.9165 4.5832C18.6069 3.89284 18.6069 2.77355 17.9165 2.0832C17.2261 1.39284 16.1069 1.39284 15.4165 2.0832L7.44753 10.0521C7.15928 10.3404 7.01515 10.4845 6.91208 10.6527C6.8207 10.8018 6.75336 10.9644 6.71253 11.1345C6.66648 11.3263 6.66648 11.5301 6.66648 11.9378V13.3332Z" stroke="#344054" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                                            </g>
                                                                                                                            <defs>
                                                                                                                                <clipPath id="clip0_3929_6825">
                                                                                                                                    <rect width="20" height="20" fill="white" />
                                                                                                                                </clipPath>
                                                                                                                            </defs>
                                                                                                                        </svg>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                                
                                                                                                            </div>
                                                                                                             {(editable || quizTemplateData?.state ===0 ) && (

                                                                                                              quizTemplateData?.state === 0 ?(
                                                                                                                <div>
                                                                                                                    <svg onClick={() => handleShowDeleteQuestion(values.questions[i], i)} className={styles.questionDeleteIcon} xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                                                                                                                        <path d="M15.4444 5.5V4.7C15.4444 3.5799 15.4444 3.01984 15.2022 2.59202C14.9892 2.21569 14.6492 1.90973 14.2311 1.71799C13.7557 1.5 13.1335 1.5 11.8889 1.5H10.1111C8.86655 1.5 8.24427 1.5 7.76891 1.71799C7.35077 1.90973 7.01082 2.21569 6.79776 2.59202C6.55556 3.01984 6.55556 3.5799 6.55556 4.7V5.5M8.77778 11V16M13.2222 11V16M1 5.5H21M18.7778 5.5V16.7C18.7778 18.3802 18.7778 19.2202 18.4145 19.862C18.0949 20.4265 17.585 20.8854 16.9577 21.173C16.2447 21.5 15.3113 21.5 13.4444 21.5H8.55556C6.68871 21.5 5.75529 21.5 5.04225 21.173C4.41505 20.8854 3.90511 20.4265 3.58553 19.862C3.22222 19.2202 3.22222 18.3802 3.22222 16.7V5.5" stroke="#B42318" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                                    </svg>
                                                                                                                </div>
                                                                                                                )
                                                                                                                :(
                                                                                                                <div>
                                                                                                                    <svg onClick={() => handleRemoveQuestion(i, setFieldValue, values)} className={styles.questionDeleteIcon} xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                                                                                                                        <path d="M15.4444 5.5V4.7C15.4444 3.5799 15.4444 3.01984 15.2022 2.59202C14.9892 2.21569 14.6492 1.90973 14.2311 1.71799C13.7557 1.5 13.1335 1.5 11.8889 1.5H10.1111C8.86655 1.5 8.24427 1.5 7.76891 1.71799C7.35077 1.90973 7.01082 2.21569 6.79776 2.59202C6.55556 3.01984 6.55556 3.5799 6.55556 4.7V5.5M8.77778 11V16M13.2222 11V16M1 5.5H21M18.7778 5.5V16.7C18.7778 18.3802 18.7778 19.2202 18.4145 19.862C18.0949 20.4265 17.585 20.8854 16.9577 21.173C16.2447 21.5 15.3113 21.5 13.4444 21.5H8.55556C6.68871 21.5 5.75529 21.5 5.04225 21.173C4.41505 20.8854 3.90511 20.4265 3.58553 19.862C3.22222 19.2202 3.22222 18.3802 3.22222 16.7V5.5" stroke="#B42318" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                                    </svg>
                                                                                                                </div>
                                                                                                                )
                                                                                                            )
                                                                                                            }
                                                                                                            {!questionStates[i] ? (
                                                                                                                <div>
                                                                                                                    <svg className={styles.toggleIcon} onClick={() => toggleState(i)} xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                                                        <path d="M5 8L10 13L15 8" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                                    </svg>
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <div>
                                                                                                                    <svg className={styles.toggleIcon} onClick={() => toggleState(i)} xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                                                        <path d="M11 6.5L6 1.5L1 6.5" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                                    </svg>
                                                                                                                </div>
                                                                                                            )}


                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {questionStates[i] && (
                                                                                                        <div className={styles.questionFieldDiv}>
                                                                                                            <div className='mt-4 ms-3'>
                                                                                                                <Row>
                                                                                                                    <Col>
                                                                                                                        <Card.Title className={styles.questionName} id={`adminPanel_evaluationTemplates_quizTemplates_viewQuizTemplate_questionId.${i}`}>{question.question}</Card.Title>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            </div>
                                                                                                            <div className={styles.rowValues}>
                                                                                                                <div>
                                                                                                                    {question.answers.map((value, index) => (
                                                                                                                        <Row xs="auto">
                                                                                                                            <Col>
                                                                                                                                {value.is_correct ? (
                                                                                                                                    <p className="mb-1" key={index}><span className={styles.correctIcon}>&#10004;</span></p>
                                                                                                                                ) : (
                                                                                                                                    <p className={styles.normalIcon} key={index}><i className="fas fa-circle"></i></p>
                                                                                                                                )}
                                                                                                                            </Col>
                                                                                                                            <Col id={`adminPanel_evaluationTemplates_quizTemplates_viewQuizTemplate_answer.${index}`}>
                                                                                                                                {value.answer}
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                    ))}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    )}
                                                                                </Draggable>
                                                                            ))}
                                                                            {provided.placeholder}
                                                                        </div>
                                                                    )}
                                                                </Droppable>
                                                            </DragDropContext>
                                                        )} }
                                                    </FieldArray>
                                                ) : (
                                                        <Col className='mt-4 mb-10'>
                                                            {quizTemplateData?.state === 0 || quizTemplateData?.state === 10 &&  (
                                                                    <p className={styles.noEvalStagesMsg}>You haven't added any Questions yet.</p>
                                                            )}
                                                        </Col>
                                                )}
                                                {(editable || quizTemplateData?.state ===0 )&& (
                                                    <div className={styles.actionBtnRaw}>
                                                        <div className={styles.actionBtn}>
                                                            <CustomButton
                                                                id="add_questions"
                                                                buttonType="button"
                                                                label="Add questions"
                                                                type="secondaryBtn"
                                                                handleClick={handleShow}
                                                                frontIcon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                        <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }

                                                            />
                                                        </div>
                                                        { quizTemplateData?.state !== 0 &&
                                                        <div className={styles.actionBtn}>
                                                            <CustomButton
                                                                id="save_template"
                                                                buttonType="submit"
                                                                label="Save Template"
                                                                type="primaryBtn"
                                                                handleClick={() => { handleSubmit() }}
                                                                frontIcon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                        <g clip-path="url(#clip0_2101_3258)">
                                                                            <path d="M13 6H6.6C6.03995 6 5.75992 6 5.54601 5.89101C5.35785 5.79513 5.20487 5.64215 5.10899 5.45399C5 5.24008 5 4.96005 5 4.4V1M15 19V12.6C15 12.0399 15 11.7599 14.891 11.546C14.7951 11.3578 14.6422 11.2049 14.454 11.109C14.2401 11 13.9601 11 13.4 11H6.6C6.03995 11 5.75992 11 5.54601 11.109C5.35785 11.2049 5.20487 11.3578 5.10899 11.546C5 11.7599 5 12.0399 5 12.6V19M19 7.32548V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H12.6745C13.1637 1 13.4083 1 13.6385 1.05526C13.8425 1.10425 14.0376 1.18506 14.2166 1.29472C14.4184 1.4184 14.5914 1.59135 14.9373 1.93726L18.0627 5.06274C18.4086 5.40865 18.5816 5.5816 18.7053 5.78343C18.8149 5.96237 18.8957 6.15746 18.9447 6.36154C19 6.59171 19 6.8363 19 7.32548Z" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_2101_3258">
                                                                                <rect width="20" height="20" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                }
                                                                backicon={
                                                                    isLoading === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                                        : ''
                                                                }
                                                            />
                                                        </div>
                                                        }
                                                    </div>
                                                )}
                                                {/* modal for create question */}
                                                {
                                                    showAddQuestionModal === true ?
                                                        <CreateQuestionModal next_index={values.questions.length} showModal={showAddQuestionModal} handleClose={handleClose} setFieldValue={setFieldValue}  refreshData={getQuizTemplateValues} id={id} quizTemplateData={quizTemplateData} />
                                                        : null
                                                }
                                            </Col>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        )}
                    </Formik>
                        {quizTemplateData?.state !== 0 && editable &&
                            <div className={styles.dangerZoneMainDiv}>
                                <div>
                                    <p className={styles.dangerZoneMainText}>Danger zone</p>
                                </div>
                                <div className={styles.dangerZoneSecondDiv}>
                                    <Row className={styles.dangerZoneSecondRow}>
                                        <Col lg={7} className={styles.dangerZoneFirstCol}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M6.6665 17.5V5.83333C6.6665 5.05836 6.6665 4.67087 6.75169 4.35295C6.98286 3.49022 7.65673 2.81635 8.51946 2.58519C8.83737 2.5 9.22486 2.5 9.99984 2.5C10.7748 2.5 11.1623 2.5 11.4802 2.58519C12.3429 2.81635 13.0168 3.49022 13.248 4.35295C13.3332 4.67087 13.3332 5.05836 13.3332 5.83333V17.5M4.33317 17.5H15.6665C16.5999 17.5 17.0666 17.5 17.4232 17.3183C17.7368 17.1586 17.9917 16.9036 18.1515 16.59C18.3332 16.2335 18.3332 15.7668 18.3332 14.8333V8.5C18.3332 7.56658 18.3332 7.09987 18.1515 6.74335C17.9917 6.42975 17.7368 6.17478 17.4232 6.01499C17.0666 5.83333 16.5999 5.83333 15.6665 5.83333H4.33317C3.39975 5.83333 2.93304 5.83333 2.57652 6.01499C2.26292 6.17478 2.00795 6.42975 1.84816 6.74335C1.6665 7.09987 1.6665 7.56658 1.6665 8.5V14.8333C1.6665 15.7668 1.6665 16.2335 1.84816 16.59C2.00795 16.9036 2.26292 17.1586 2.57652 17.3183C2.93304 17.5 3.39975 17.5 4.33317 17.5Z" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <div className='ms-3'>
                                                <p className={styles.dangerZoneFirstText}>Disable Quiz Template </p>
                                                <p className={styles.dangerZoneSecondText}>Disabling quiz template modifications. Action is irreversible.</p>
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <CustomButton
                                                buttonType="button"
                                                label="Disable"
                                                type="dangerBtn"
                                                id="Disable"
                                                handleClick={() => checkEligiblityToDisable()}
                                                disabled={quizTemplateData?.state === 0 || quizTemplateData?.state === -10}
                                                backicon={
                                                    disableButtonLoading === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                        : ''
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        }

                    </div >
            }
        </div>
    )
}

export default ViewQuizTemplates;